module.exports = __webpack_public_path__ + "img/plus-solid.2671d765.svg";